import { render, staticRenderFns } from "./deleteRefundDialog.vue?vue&type=template&id=ba99159a&"
import script from "./deleteRefundDialog.vue?vue&type=script&lang=js&"
export * from "./deleteRefundDialog.vue?vue&type=script&lang=js&"
import style0 from "./deleteRefundDialog.vue?vue&type=style&index=0&id=ba99159a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports